import React, { Component } from 'react'
import UIkit from 'uikit'
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { connect } from 'react-redux'
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'
import SouscriptionSwitcher from '../../components/SouscriptionSwitcher'
import serializeForm from 'form-serialize'
import { Redirect } from 'react-router-dom'
import moment from '../../utils/helpers/moment'
import 'react-datepicker/dist/react-datepicker.css'
import ValidationDatePicker from "../../components/ValidationDatePicker/souscripteur";
import ValidationInput from "../../components/ValidationInput";
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import { fetchSouscripteurAction, fetchAddSouscripteurAction, fetchUpdateSouscripteurAction } from '../../actions/Souscription/Souscripteur'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class Souscripteur extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
      submitSouscripteurSuccess: false,
      isSouscripteurData: false,
      isEntreprise: false,
      isCurrNewSouscription: false,
      localSouscripteurData: {},
      notificationGetSouscripteurError: false,
      notificationAddSouscripteurError: false,
      notificationUpdateSouscripteurError: false,
      startBirthday: null,
      formErrors: {},
      form: {}
    }
    this.handleChangeDatePickerBirthday = this.handleChangeDatePickerBirthday.bind(this)
  }

  componentDidMount() {
    document.title = `Dashboard Membre | Souscripteur`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, getReauthenticateCourtiers, reauthenticateMembers, reauthenticateCourtiers, userGetSouscripteur } = this.props

    if(this.props.location.state) {
      if(this.props.location.state.fromEntrepriseSubscribe) {
        this.setState({isEntreprise: this.props.location.state.fromEntrepriseSubscribe})
      }
    }
    
    if (isCurrentLoginCourtier) {
      if (Object.keys(reauthenticateCourtiers.courtierData).length === 0) {
        getReauthenticateCourtiers()
      }

      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      } else if(!this.props.location.state) {
        this.setState({ isCurrNewSouscription: true })
      } else {
        if (Object.keys(reauthenticateCourtiers.courtierData).length !== 0) {
          this.setState({ localSouscripteurData: {
            firstname: "",
            lastname: "",
            birthday: "",
            nationality: "",
            address: "",
            telephone: "",
            email: "",
          } })
          
          if(!this.props.location.state) {
            this.setState({ isCurrNewSouscription: true })
          }
        }
      }
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0) {
        getReauthenticate()
      }
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      } else if(!this.props.location.state) {
        this.setState({ isCurrNewSouscription: true })
      } else {
        if (Object.keys(reauthenticateMembers.userData).length !== 0) {
          this.setState({ localSouscripteurData: { ...reauthenticateMembers.userData } })

          if(!this.props.location.state) {
            this.setState({ isCurrNewSouscription: true })
          }
        }
      }
    }
  }
  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateMembers, reauthenticateCourtiers, userGetSouscripteur, getSouscripteur } = nextProps

    if (reauthenticateMembers.userData.length !== this.props.reauthenticateMembers.userData.length) {
      if (reauthenticateMembers.userData.souscripteurID) {
        this.setState({ localSouscripteurData: {} })
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }else {
        this.setState({ localSouscripteurData: { ...reauthenticateMembers.userData} })
      }
    }
    if (reauthenticateCourtiers.courtierData.length !== this.props.reauthenticateCourtiers.courtierData.length) {
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        this.setState({ localSouscripteurData: {
          firstname: "",
          lastname: "",
          birthday: "",
          nationality: "",
          address: "",
          telephone: "",
          email: "",
        } })
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }else {
        this.setState({ localSouscripteurData: {
          firstname: "",
          lastname: "",
          birthday: "",
          nationality: "",
          address: "",
          telephone: "",
          email: "",
        } })
      }
    }
    if (getSouscripteur.souscripteurData.length !== this.props.getSouscripteur.souscripteurData.length) {
      this.handleChangeDatePickerBirthday(moment(getSouscripteur.souscripteurData.birthday))
      this.setState({ isSouscripteurData: true, localSouscripteurData: { ...getSouscripteur.souscripteurData }, isEntreprise: getSouscripteur.souscripteurData.isEntreprise })
    }

    if (nextProps.getSouscripteur.isError !== this.props.getSouscripteur.isError) {
      this.setState({ notificationGetSouscripteurError: nextProps.getSouscripteur.isError })
    }
    if (nextProps.addSouscripteur.isError !== this.props.addSouscripteur.isError) {
      this.setState({ notificationAddSouscripteurError: nextProps.addSouscripteur.isError })
    }
    if (nextProps.updateSouscripteur.isError !== this.props.updateSouscripteur.isError) {
      this.setState({ notificationUpdateSouscripteurError: nextProps.updateSouscripteur.isError })
    }
    if (nextProps.addSouscripteur.isSuccess !== this.props.addSouscripteur.isSuccess
      || nextProps.updateSouscripteur.isSuccess !== this.props.updateSouscripteur.isSuccess)  {
      this.setState({submitSouscripteurSuccess: (nextProps.addSouscripteur.isSuccess || nextProps.updateSouscripteur.isSuccess)})
    }
  }

  handleChangeDatePickerBirthday(date) {
    this.setState({ startBirthday: date })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { isCurrentLoginCourtier } = this.state
    const { userAddSouscripteur, userUpdateSouscripteur, reauthenticateMembers, reauthenticateCourtiers } = this.props
    const FormValues = serializeForm(event.target, { hash: true })
    FormValues["birthday"] = moment(FormValues.birthday, "DD-MMM-YYYY").valueOf()

    if(this.state.isEntreprise) {
      FormValues["isEntreprise"] = this.state.isEntreprise

      FormValues["firstname"] = `(${FormValues.firstname})`
    }

    if (Object.keys(FormValues).length !== 0) {
      if (isCurrentLoginCourtier) {
        FormValues["checkType"] = "courtier"

        if(reauthenticateCourtiers.isSuccess) {
          if (reauthenticateCourtiers.courtierData.souscripteurID) {
            userUpdateSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID, serializeJavascript.sanitize(FormValues))
          }else {
            FormValues["parentCode"] = reauthenticateCourtiers.courtierData.codeApporteur
            userAddSouscripteur(isCurrentLoginCourtier, "", serializeJavascript.sanitize(FormValues))
          }
        }
      }else {
        FormValues["checkType"] = "direct"

        if (reauthenticateMembers.isSuccess && reauthenticateMembers.userData.souscripteurID) {
          userUpdateSouscripteur(reauthenticateMembers.userData.souscripteurID, serializeJavascript.sanitize(FormValues))
        }else {
          FormValues["userCode"] = reauthenticateMembers.userData.userCode
          if (reauthenticateMembers.userData.parentCode) {
            FormValues["parentCode"] = reauthenticateMembers.userData.parentCode
            userAddSouscripteur(isCurrentLoginCourtier, reauthenticateMembers.userData._id, serializeJavascript.sanitize(FormValues))
          }else {
            userAddSouscripteur(isCurrentLoginCourtier, reauthenticateMembers.userData._id, serializeJavascript.sanitize(FormValues))
          }
        }
      }
    }
  }
  handleOnDateChange = (date, errorPayload) => {
    let err = errorPayload;
    let value = date;
    this.setState((prev, props) => {
      prev.formErrors[err.name] = !err.hasError;
      prev.form[err.name] = value;
      return { formErrors: prev.formErrors, form: prev.form };
    });
  }
  handleOnChange = (event, errorPayload) => {
    let err = errorPayload;
    let value = event.target.value
    this.setState((prev, props) => {
      prev.formErrors[err.name] = !err.hasError;
      prev.form[err.name] = value;
      return { formErrors: prev.formErrors, form: prev.form };
    });
  }
  handleOnError = (event, errorPayload) => {
    let err = errorPayload;
    this.setState((prev, props) => {
      prev.formErrors[err.name] = !err.hasError;
      return { formErrors: prev.formErrors };
    });
  }
  applyGetSouscripteur() {
    const { getSouscripteur } = this.props
    this.setState({ localSouscripteurData: { ...getSouscripteur.souscripteurData } })
  }

  NotificationGetSouscripteurError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur récuperation souscripteur",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationGetSouscripteurError: false })
  }
  NotificationAddSouscripteurError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur ajout souscripteur",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationAddSouscripteurError: false })
  }
  NotificationUpdateSouscripteurError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur mise à jour souscripteur",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationUpdateSouscripteurError: false })
  }

  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers, getSouscripteur, addSouscripteur, updateSouscripteur } = this.props
    const { startBirthday, submitSouscripteurSuccess, isSouscripteurData, localSouscripteurData,
          notificationGetSouscripteurError,
          notificationAddSouscripteurError,
          formErrors,
          notificationUpdateSouscripteurError,
          isEntreprise,
          isCurrentLoginCourtier,
          isCurrNewSouscription,} = this.state
    let invalidForm  = Object.values(formErrors).length && !Object.values(formErrors).reduce((a, b) => a && b)

    if (isSouscripteurData && !localSouscripteurData) {
      this.applyGetSouscripteur()
    }

    return(
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
        {(getSouscripteur.souscripteurData.status === "submitted" || getSouscripteur.souscripteurData.status === "payment-pending") && <Redirect to="/soumis" push/>}
          {getSouscripteur.souscripteurData.status === "police-active" && <Redirect to="/validation-souscription" push/>}
          {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-menu-tab-content">
                  <SouscriptionSwitcher match={match} />
                    {(getSouscripteur.isLoading || addSouscripteur.isLoading || updateSouscripteur.isLoading || localSouscripteurData === undefined)
                      ?
                        <div className="aps-spinner-component-loading">
                          <div className="uk-spinner">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                               <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                            </svg>
                          </div>
                          <div className="aps-section-register-desc">chargement en cours</div>
                        </div>
                      :
                      <div>
                        {isCurrNewSouscription &&
                          <div>
                            <Redirect to='/user-type' push/>
                          </div>
                        }
                        {isEntreprise
                          ?
                            <div className="uk-text-center aps-dashboard-souscripteur-title uk-text-bold">
                              Personne morale (Entreprise)
                            </div>
                          :
                            <div className="uk-text-center aps-dashboard-souscripteur-title uk-text-bold">
                              Personne physique (Particulier)
                            </div>
                        }
                        {getSouscripteur.isError && notificationGetSouscripteurError &&
                          <div>
                            { this.NotificationGetSouscripteurError() }
                          </div>
                        }
                        {addSouscripteur.isError && notificationAddSouscripteurError &&
                          <div>
                            { this.NotificationAddSouscripteurError() }
                          </div>
                        }
                        {updateSouscripteur.isError && notificationUpdateSouscripteurError &&
                          <div>
                            { this.NotificationUpdateSouscripteurError() }
                          </div>
                        }
                        {((localSouscripteurData && Object.keys(localSouscripteurData).length !== 0)) &&
                          (
                            <form onSubmit={this.handleSubmit}>
                              <div className="aps-section-resgister-souscripteur-form">
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">
                                  {
                                    isEntreprise ? "Dénomination sociale" : "Nom"
                                  }
                                  </p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <ValidationInput
                                      type="text"
                                      placeholder={
                                        isEntreprise ? "Dénomination sociale" : "Votre Nom"
                                      } 
                                      name="firstname"
                                      checkFullFields={
                                        !localSouscripteurData.firstname && true
                                      }
                                      checkTypeVal={true}
                                      defaultValue={localSouscripteurData.firstname && localSouscripteurData.firstname}
                                      onBlur={(errorPayload, event) =>
                                        this.handleOnError(event, errorPayload)
                                      }
                                      onChange={(errorPayload, event) =>
                                        this.handleOnChange(
                                          event,
                                          errorPayload
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">
                                  {
                                    isEntreprise ? "Prénom + Nom du salarié (assuré principal)" : "Prénom(s)"
                                  }</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <ValidationInput
                                      type="text"
                                      placeholder={
                                        isEntreprise ? "Prénom + Nom" : "Votre prénom"
                                      }
                                      name="lastname"
                                      checkTypeVal={true}
                                      checkFullFields={
                                        !localSouscripteurData.lastname && true
                                      }
                                      defaultValue={localSouscripteurData.lastname && localSouscripteurData.lastname}
                                      onBlur={(errorPayload, event) =>
                                        this.handleOnError(event, errorPayload)
                                      }
                                      onChange={(errorPayload, event) =>
                                        this.handleOnChange(
                                          event,
                                          errorPayload
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                
                                {!isEntreprise && (
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">Date de naissance :</p>
                                  <div className="uk-inline aps-section-register-fields-full aps-section-register-fields-full-date-picker">
                                    <ValidationDatePicker
                                      dateFormat="DD-MMM-YYYY"
                                      name="birthday"
                                      placeholderText="Votre date de naissance (ex: 12 Mai 1991)"
                                      locale="fr"
                                      peekNextMonth 
                                      maxDate={moment().add(0, 'd')}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      selected={startBirthday}
                                      onBlur={(errorPayload, event) =>
                                        this.handleOnError(event, errorPayload)
                                      }
                                      onChange={(errorPayload, date) => {
                                        this.handleChangeDatePickerBirthday(date)
                                        this.handleOnDateChange(
                                          date,
                                          errorPayload
                                        )
                                        }
                                      }
                                    />
                                  </div>
                                </div>)}
                                
                                {!isEntreprise && (
                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">Nationalité</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <ValidationInput
                                      type="text"
                                      placeholder="Précisez votre nationalité"
                                      name="nationality"
                                      checkTypeVal={true}
                                      checkFullFields={
                                        !localSouscripteurData.nationality && true
                                      }
                                      defaultValue={localSouscripteurData.nationality && localSouscripteurData.nationality}
                                      onBlur={(errorPayload, event) =>
                                        this.handleOnError(event, errorPayload)
                                      }
                                      onChange={(errorPayload, event) =>
                                        this.handleOnChange(
                                          event,
                                          errorPayload
                                        )
                                      }
                                    />
                                  </div>
                                </div>)}

                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  {isEntreprise
                                    ?
                                      <p className="uk-text-left aps-section-contacter-fields-name">Adresse</p>
                                    :
                                      <p className="uk-text-left aps-section-contacter-fields-name">Adresse de résidence</p>
                                  }
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <ValidationInput
                                      type="text"
                                      placeholder={isEntreprise ? "Adresse" : "Adresse de résidence"}
                                      name="address"
                                      checkTypeVal={true}
                                      checkFullFields={
                                        !localSouscripteurData.address && true
                                      }
                                      defaultValue={localSouscripteurData.address && localSouscripteurData.address}
                                      onBlur={(errorPayload, event) =>
                                        this.handleOnError(event, errorPayload)
                                      }
                                      onChange={(errorPayload, event) =>
                                        this.handleOnChange(
                                          event,
                                          errorPayload
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">Tél</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <ValidationInput
                                      type="text"
                                      placeholder="Votre numéro (ex: 90 00 00 00)"
                                      name="telephone"
                                      checkTypeVal={true}
                                      checkFullFields={
                                        !localSouscripteurData.telephone && true
                                      }
                                      defaultValue={localSouscripteurData.telephone && localSouscripteurData.telephone}
                                      onBlur={(errorPayload, event) =>
                                        this.handleOnError(event, errorPayload)
                                      }
                                      onChange={(errorPayload, event) =>
                                        this.handleOnChange(
                                          event,
                                          errorPayload
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                                  <p className="uk-text-left aps-section-contacter-fields-name">E-mail</p>
                                  <div className="uk-inline aps-section-register-fields-full">
                                    <ValidationInput
                                      type="email"
                                      placeholder="Votre email (ex : adresse@email.com)"
                                      name="email"
                                      checkTypeVal={true}
                                      checkFullFields={
                                        !localSouscripteurData.email && true
                                      }
                                      defaultValue={localSouscripteurData.email && localSouscripteurData.email}
                                      onBlur={(errorPayload, event) =>
                                        this.handleOnError(event, errorPayload)
                                      }
                                      onChange={(errorPayload, event) =>
                                        this.handleOnChange(
                                          event,
                                          errorPayload
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="aps-dashboard-souscription-switch">
                                <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-first">
                                  <button
                                    className={`uk-button aps-btn-green aps-btn-green-dashboard-btn  ${invalidForm ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                                    disabled={Object.values(formErrors).length && !Object.values(formErrors).reduce((a, b) => a && b)}
                                  >
                                    Section suivante
                                  </button>
                                </div>
                              </div>
                            </form>
                          )
                        }
                      </div>
                    }
                </div>
                {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
                {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion-intermediaires' push/>
                  </div>
                }
                {(addSouscripteur.isSuccess || updateSouscripteur.isSuccess) && submitSouscripteurSuccess &&
                  <div><Redirect to="/beneficiaire" push/></div>
                }
              </Dashboard>
            }
          <Footer />
        </div>
      )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers, getSouscripteur, addSouscripteur, updateSouscripteur }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
    getSouscripteur,
    addSouscripteur,
    updateSouscripteur,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
    userGetSouscripteur: (souscripteurID) => dispatch(fetchSouscripteurAction(souscripteurID)),
    userAddSouscripteur: (isCurrentLoginCourtier, userID, souscripteurData) => dispatch(fetchAddSouscripteurAction(isCurrentLoginCourtier, userID, souscripteurData)),
    userUpdateSouscripteur: (souscripteurID, souscripteurData) => dispatch(fetchUpdateSouscripteurAction(souscripteurID, souscripteurData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Souscripteur)



// WEBPACK FOOTER //
// ./src/containers/Souscripteur/index.js